// extracted by mini-css-extract-plugin
module.exports = {"title":"FormWrapper_title_2xNK9","wrapper":"FormWrapper_wrapper_22dK2","content":"FormWrapper_content_3syoX"};